import store from '../store'


const needAuth = auth => auth === true

const beforeEach = (to, from, next) => {
  const auth = to.meta.requiresAuth


  /**
  * Clears all global feedback message
  * that might be visible
  */
  // store.dispatch('resetMessages')

  // if(auth){
  //   // const authUser = JSON.parse(window.localstorage.getItem(userTokenStorageKey));
  //   const authUser = localStorage.getItem('loginData');
  //   // console.log(authUser.token);

  //   // if(!authUser){
  //   // // if(!authUser||!authUser.token){
  //   //   next({name:'auth.login'});
  //   // }
  // }

  /**
   * If route doesn't require authentication be normally accessed.
   */
  if (!needAuth(auth)) {
    next()
    return // return to prevent the code from continuing in its flow
    // With this flow `else` or `else if` is not necessary
  }

  /**
   * Otherwise  if authentication is required login.
   */
  store.dispatch('checkUserToken')
    .then(() => {
      // There is a token and it is valid
      next() // can access the route
    })
    .catch(() => {
      
      // No token, or it is invalid
      next({ name: 'auth.login' }) // redirect to login
    })
}

export default beforeEach



// WEBPACK FOOTER //
// ./src/router/beforeEach.js